import { ObjectHelpers } from "../../helpers/object-helpers";
import { TradeAccountModel } from "../trade/trade-account.model";

export class DrawOrderExecutionModel {
    public tooltip = '';
    public symbol = '';
    public imageAnnotationName = '';
    public x = 0;
    public y = 0;

    public accounts: Array<TradeAccountModel> = [];
    public executionIds: Array<string> = [];
    
    private key = '';

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
            this.setKey();
        }
    }

    public getKey(): string {
        return this.key;
    }

    private setKey() {
        const ids = this.extractIds();
        this.key = 'doe-' + ids.join('-');
    }

    private extractIds(): Array<string> {
        if (this.executionIds?.length) {
            return this.executionIds;
        }

        if (!this.tooltip) return [];
        // Regular expression to match exec ids
        let execIds: string[] = [];
        const regex = /exec id: (\d+)/g;
        let match: RegExpExecArray | null;

        // Iterate over each match in the message
        while ((match = regex.exec(this.tooltip)) !== null) {
            // Extract the exec id and push it to the array
            if (match[1]) {
                execIds.push(match[1]);
            }
        }

        return execIds;
    }

    public getImageAndClass(basePath: string, version: number): Array<string> {
        if (version == 2) {
            if (this.imageAnnotationName == 'EXECUTION_BUY_TO_COVER_LIGHT' || this.imageAnnotationName == 'EXECUTION_BUY_TO_COVER_DARK') {
                return [basePath + 'assetfiles/img/buy-arrow-v2-4.png', 'right'];
            } else if (this.imageAnnotationName == 'EXECUTION_BUY_LIGHT' || this.imageAnnotationName == 'EXECUTION_BUY_DARK') {
                return [basePath + 'assetfiles/img/buy-arrow-v2-4.png', 'right'];
            } else if (this.imageAnnotationName == 'EXECUTION_SELL_LIGHT' || this.imageAnnotationName == 'EXECUTION_SELL_DARK') {
                return [basePath + 'assetfiles/img/sell-arrow-v2-4.png', 'right'];
            } else if (this.imageAnnotationName == 'EXECUTION_SHORT_LIGHT' || this.imageAnnotationName == 'EXECUTION_SHORT_DARK') {
                return [basePath + 'assetfiles/img/sell-arrow-v2-4.png', 'right'];
            }
        } else {
            if (this.imageAnnotationName == 'EXECUTION_BUY_TO_COVER_LIGHT' || this.imageAnnotationName == 'EXECUTION_BUY_TO_COVER_DARK') {
                return [basePath + 'assetfiles/img/B_pointingLeft.png', 'left'];
            } else if (this.imageAnnotationName == 'EXECUTION_BUY_LIGHT' || this.imageAnnotationName == 'EXECUTION_BUY_DARK') {
                return [basePath + 'assetfiles/img/B_pointingRight.png', 'right'];
            } else if (this.imageAnnotationName == 'EXECUTION_SELL_LIGHT' || this.imageAnnotationName == 'EXECUTION_SELL_DARK') {
                return [basePath + 'assetfiles/img/S_pointingLeft.png', 'left'];
            } else if (this.imageAnnotationName == 'EXECUTION_SHORT_LIGHT' || this.imageAnnotationName == 'EXECUTION_SHORT_DARK') {
                return [basePath + 'assetfiles/img/S_pointingRight.png', 'right'];
            }
        }
        return ['', ''];
    }
}